import { render, staticRenderFns } from "./SpotlightSummary.vue?vue&type=template&id=18df1af1&"
import script from "./SpotlightSummary.vue?vue&type=script&lang=js&"
export * from "./SpotlightSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports